import React, { Suspense, useState } from 'react'

import { useLazyLoadQuery, graphql } from 'react-relay'
import { useLocation, useNavigate } from 'react-router-dom'

import { XStack, styled, View } from 'tamagui'

import { Text } from '../Text'
import { Link } from '../Link'
import { Spinner } from '../Spinner'
import { Group } from '../Group'
import { Icon } from '../Icon'

export const DynamicIslandHomeExpand = () => {
  const [itemHovered, setItemHovered] = useState<
    'guilds' | 'events' | 'presentations' | undefined
  >()

  return (
    <Group
      gap='$2'
      highlightedElementProps={{
        borderRadius: '$6',
        backgroundColor: '$lightBlue1',
      }}
      marginHorizontal={-4}
      onHoverOut={() => setItemHovered(undefined)}
    >
      <Group.Item index={0}>
        <Link
          href='/guilds'
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('guilds')}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'guilds' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='people' />
            </StyledIconWrapper>

            <Text>Guilds</Text>
          </XStack>
        </Link>
      </Group.Item>

      <Group.Item index={1}>
        <Link
          href='/events'
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('events')}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'events' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='calendar' />
            </StyledIconWrapper>

            <Text>Events</Text>
          </XStack>
        </Link>
      </Group.Item>

      <Group.Item index={2}>
        <Link
          href='/presentations'
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('presentations')}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'presentations' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='people-community' />
            </StyledIconWrapper>

            <Text>Presentations</Text>
          </XStack>
        </Link>
      </Group.Item>
    </Group>
  )
}

const StyledIconWrapper = styled(View, {
  animation: 'fastSpring',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: '$grey3',
  width: '$6',
  height: '$6',
})

const StyledIcon = styled(Icon, {
  size: '$5',
  padding: 0,
})
